import { Redirect } from 'react-router-dom';

import { ROUTES } from 'constants/routes';
import { getMod } from 'services/hooks';

export const LifeGoals = () => {
  const Screen = getMod('lifeGoals')?.screens.LifeGoals;

  if (Screen) {
    return <Screen />;
  }

  return <Redirect to={ROUTES.home} />;
};
